import React, { useState, useEffect } from "react";
import Header from "common/js/header/header";
import Loader from "common/components/Loader";
import { ToastContainer } from "react-toastify";
import booksData from "./books.json";
import BookCard from "./bookCard";

const BooksCtrl = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [lstBooks, setLstBooks] = useState([]);
    const [bookPairs, setBookPairs] = useState([]);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        setLstBooks(booksData);
        setBookPairs(getBookPairs(booksData));
    }, []);


    const readBook = (bookId) => {
        // console.log("readBook called", bookId);
        let newUrl = "/bookUsage?bookId=" + bookId;
        window.location.href = newUrl;
    };

    // Group books in pairs for each row (2 books per row)
    const getBookPairs = (books) => {
        const pairs = [];
        for (let i = 0; i < books.length; i += 2) {
            pairs.push(books.slice(i, i + 2));
        }
        return pairs;
    };

    const handleFilterBooks = () => {
        // console.log("handleFilterBooks called with searchText:", searchText);
        const filtered = lstBooks.filter(book =>
            book.book.toLowerCase().includes(searchText.toLowerCase()) ||
            book.tags.toLowerCase().includes(searchText.toLowerCase())
        );
        // console.log("Filtered books:", filtered);
        setBookPairs(getBookPairs(filtered));
    }


    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div
                className="col-lg-8 col-md-8 col-sm-10 col-xs-12 col-centered padding-remove"
                style={{
                    marginTop: "20px",
                    opacity: opacity,
                    pointerEvents: opacity === 1 ? "auto" : "none",
                    cursor: opacity === 1 ? "pointer" : "default"
                }}
            >
                <div className="col-sm-12 col-centered padding-remove">
                    <div className="col-sm-12 col-centered padding-remove"
                        style={{ marginBottom: 24, display: "flex", }}>
                        <div style={{ position: "relative", width: 320 }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search books..."
                                style={{
                                    borderRadius: 24,
                                    padding: "10px 40px 10px 28px",
                                    fontSize: 16
                                }}
                                value={searchText}
                                onChange={e => setSearchText(e.target.value)}
                            />
                            <span
                                className="glyphicon glyphicon-search"
                                style={{
                                    position: "absolute",
                                    right: 14,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#78909c",
                                    fontSize: 20,
                                    cursor: "pointer"
                                }}
                                onClick={handleFilterBooks}
                            />
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            overflowY: "auto",
                            height: "calc(100vh - 180px)",
                            gap: 24,
                            padding: "8px 0"
                        }}
                    >
                        {bookPairs.map((pair, rowIdx) => (
                            <div
                                key={rowIdx}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    width: "100%"
                                }}
                            >
                                {pair.map((book) => (
                                    <BookCard
                                        key={book.bookId}
                                        book={book}
                                        readBook={readBook}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BooksCtrl;